'use client';

import { RefObject, useRef } from 'react';
import { isFilled } from '@prismicio/client';

import { Box, Heading, List, ListItem } from '@preventx/oxygen';

// Types
import { ISOLanguageKeys } from '@/types/language';
import { DropdownPanel as DropdownPanelElement } from '@/types/navigation/panel';

// Components
import { Link } from '@/components/Actions/Link';
import { Section } from '@/components/Site/Navigation/Standard/Section';

type DropdownPanelProps = {
  id: string;
  onNavigate: () => void;
  language: string | ISOLanguageKeys;
  configuration: DropdownPanelElement;
  ref: RefObject<HTMLDivElement | null>;
};

export const DropdownPanel = ({
  id,
  ref,
  language,
  onNavigate,
  configuration,
}: DropdownPanelProps) => {
  const { label, meta, sectionOne, sectionTwo, sectionThree } = configuration;

  return (
    <Box component="div" addFlow>
      <Heading component="h3" className="stack-nav__heading">
        {label}
      </Heading>

      <Box component="div" addFlow>
        {sectionOne && (
          <Section
            id={id}
            ref={ref}
            isNavigationDrawer
            language={language}
            section={sectionOne}
          />
        )}

        {sectionTwo && (
          <Section
            id={id}
            ref={ref}
            isNavigationDrawer
            language={language}
            section={sectionTwo}
          />
        )}

        {sectionThree && (
          <Section
            id={id}
            ref={ref}
            isNavigationDrawer
            language={language}
            section={sectionThree}
          />
        )}

        {meta && (meta?.links ?? []).length > 0 && (
          <Box
            addRepel
            component="nav"
            aria-label={meta.label}
            className="dropdown__meta"
          >
            <List component="ul" addCluster style="stack-nav">
              {meta.links.map((link, index) => {
                if (!isFilled.link(link)) {
                  return null;
                }

                return (
                  <ListItem key={`dropdown-panel-meta-${id}-${index + 1}`}>
                    <Link
                      href={link}
                      type="link"
                      as="default"
                      retainSearchParams
                      onClick={onNavigate}
                    >
                      {link.text}
                    </Link>
                  </ListItem>
                );
              })}
            </List>
          </Box>
        )}
      </Box>
    </Box>
  );
};
